export type UserInfoActionTypes = UpdateUserInfoAction | InitFetchUserInfoAction | EndFetchUserInfoAction;

export const UPDATE_USERINFO = "UPDATE_USERINFO";
export interface UpdateUserInfoAction {
    type: typeof UPDATE_USERINFO;
    updateUserInfoActionPayload: UpdateUserInfoActionPayload;
}

export const INIT_FETCH_USERINFO = "INIT_FETCH_USERINFO";
export interface InitFetchUserInfoAction {
    type: typeof INIT_FETCH_USERINFO;
}

export const END_FETCH_USERINFO = "END_FETCH_USERINFO";
export interface EndFetchUserInfoAction {
    type: typeof END_FETCH_USERINFO;
}

export interface UpdateUserInfoActionPayload {
    userInformation: any
};